<template>
    <b-sidebar
        id="add-new-user-sidebar"
        :visible="isAddNewUserSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @hidden="isAddNewUserSidebarActive = false"
        @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">
                    Add New Penerimaan
                </h5>

                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>
            <b-col>
                <b-form-group label="Upload From Excel Docs" label-cols-sm="6">
                    <b-form-file :disabled="isLoading" v-model="file"></b-form-file>
                </b-form-group>
                <b-button :disabled="!file || isLoading" @click="sendExcel"><b-spinner small v-show="isLoading"></b-spinner> Upload</b-button>
            </b-col>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BModal,
    BFormTextarea,
    BCol, BFormFile, BSpinner
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import inject, { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import router from '@/router'
export default {
  components: {
    Password : () => import('vue-password-strength-meter'),
      DatePicker  : () => import('vue2-datepicker'),
      BCol,
      BFormFile,
    BSidebar,
    BForm,
      BSpinner,
      BModal,
      BFormTextarea,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
      isAddNewUserSidebarActive: {
          type: Boolean,
          required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
    }
  },
  setup(props, { emit }) {
      let blankUserData = {
          warehouse: null,
          supplier:null,
          noPenerimaan: '',
          tgl_terima: '',
          keterangan: '',
          gerai: null,
        }
    const isLoading = ref(false)
    const file = ref(null)
    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))

    const setSelected =  (value) =>
      {
          userData.value.gerai = value.gerai
          //  trigger a mutation, or dispatch an action
      }
      const sendExcel = async () => {
          isLoading.value = true
          store.dispatch('app-penerimaan/uploadRincianPenerimaan', {
              file: file.value,
              id: router.currentRoute.params.id
          }).then(async response => {
              emit('refetch-data')
              emit('update:is-add-new-user-sidebar-active', false)
          }).finally(async e => {
              file.value = null
              isLoading.value = false
          })
      }


      const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }
    const onSubmit = () => {
      store.dispatch('app-penerimaan/addPenerimaan', userData.value).then(() =>  {
        emit('refetch-data')
        emit('update:is-add-new-user-sidebar-active', false)
      })
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetuserData)

    return {
        file,
        sendExcel,
        setSelected,
        userData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
        isLoading
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
